import React from 'react';
import { AutoAwesome, Translate } from '@mui/icons-material';
import { SystemRoles } from '../types/generic';
import { SvgIconProps } from '@mui/material';

interface EnrichmentOption {
	label: string;
	desc: string;
	icon: React.ElementType<SvgIconProps>;
	reqRole: SystemRoles;
}

export const ENRICHMENT_OPTIONS: Record<string, EnrichmentOption> = {
	language: {
		label: 'Language Translation',
		desc: 'Attempts to identify the most likely language for a message, then performs a slang-and-context-aware translation',
		icon: Translate,
		reqRole: 'ENRICH_LANGUAGE',
	},
	summarisation: {
		label: 'AI Summary (coming soon)',
		desc: 'Generates a summary of the information inside a message thread',
		icon: AutoAwesome,
		reqRole: 'ENRICH_SUMMARY',
	},
};
